import { KyInstance } from 'ky';
import qs from 'qs';

import { CommonQueryParams, CommonResponse } from '../common';
import { Zone } from './zone.model';

export async function getZones(httpClient: KyInstance, baseOptions: CommonQueryParams) {
  const allData: Zone[] = [];
  let page = 1;
  const pageSize = baseOptions?.pagination?.pageSize || 100;

  while (true) {
    const options = {
      populate: '*',
      ...baseOptions,
      pagination: { page, pageSize },
    };

    const searchParams = qs.stringify(options, { encodeValuesOnly: true });
    const response = await httpClient.get('zones', { searchParams });
    const json = (await response.json()) as CommonResponse<Zone>;

    allData.push(...json.data);

    const meta = json.meta?.pagination;
    if (!meta || page >= meta.pageCount) break;

    page++;
  }

  return {
    data: allData,
  };
}
